import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef6bb6c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content-list"
};
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => _ctx.selected(item)
    }, [_createElementVNode("div", {
      class: _normalizeClass(["label-slot", {
        checked: _ctx.runnerCount === item
      }])
    }, [_createElementVNode("p", null, _toDisplayString(item) + "个", 1)], 2)], 8, _hoisted_2);
  }), 128))]);
}